import Link from "next/link";
import React, { useState, useEffect, useContext } from "react";
import Image from "next/image";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import Head from "next/head";
import Meta from "../Meta";
import {
  collectRenkingData,
  updateCollectionList,
  updateTrendingCategoryItemData,
} from "../../redux/marketplaceSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  getCollectionListings,
  getAllCollection,
  // getCollectionsByContract,
} from "../../utils/api";

import { DECIMAL } from "../../config";
import { GetSolNftDataContext } from "../../contexts/SolNftContext";
import PhantomLogo from "../../public/phantom.png";

const SolCollectionList = () => {
  const { collectionData } = useContext(GetSolNftDataContext);
  return (
    <>
      <Meta title="Nut Market " />
      {/* <!-- Rankings --> */}
      <section className="relative lg:mt-24 lg:pb-24 pb-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 hidden">
          <Image
            src="/images/gradient_light.jpg"
            layout="fill"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <h1 className="font-display py-8 text-center text-4xl font-medium text-white">
            Collection
          </h1>

          {/* <!-- Filters --> */}
          <div className="mb-8 flex flex-wrap items-center justify-between">
            <div className="flex flex-wrap items-center">
              {/* <!-- Categories --> */}
              {/* <Recently_added_dropdown
                data={categoryText}
                dropdownFor="rankingCategories"
              /> */}

              {/* <!-- Chains --> */}
              {/* <Recently_added_dropdown
                data={blockchainText}
                dropdownFor="blockchain"
              /> */}
            </div>

            {/* last 7 days */}
            {/* <Recently_added_dropdown
              data={last7DaysRanks}
              dropdownFor="last7Days-ranks"
            /> */}

            {/* <!--  --> */}
          </div>
          {/* <!-- end filters --> */}

          {/* <!-- Table --> */}
          <div className="scrollbar-custom overflow-x-auto">
            <div
              role="table"
              className="bg-jacarta-700 border-jacarta-600  lg:rounded-2lg w-full min-w-[736px] border  text-sm text-white"
            >
              <div className="bg-jacarta-600  rounded-t-2lg flex" role="row">
                <div className="w-[28%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Collection
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Volume
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    24h %
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    7d %
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Floor Price
                  </span>
                </div>
                <div className="w-[24%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Owners
                  </span>
                </div>
              </div>
              {collectionData.map((item, index) => (
                <Link
                  href={`/collection/${item.collectionAddr}?network=solana`}
                  key={index}
                >
                  <a
                    className="flex transition-shadow hover:shadow-lg"
                    role="row"
                  >
                    <div
                      className="border-jacarta-600  flex w-[28%] items-center border-t py-4 px-4"
                      role="cell"
                    >
                      <figure className="relative mr-2 w-8 shrink-0 self-start lg:mr-5 lg:w-12">
                        {/* <img src={image} alt={title} className="rounded-2lg" loading="lazy" /> */}
                        <img
                          src={item.imgUrl}
                          alt={""}
                          layout="responsive"
                          objectfit="contain"
                          className="rounded-2lg w-[40px] h-[40px] object-cover"
                          loading="lazy"
                        />

                        {/* {icon && (
                          <div
                            className="border-jacarta-600 bg-green absolute -right-2 -bottom-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                            data-tippy-content="Verified Collection"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              className="h-[.875rem] w-[.875rem] fill-white"
                            >
                              <path fill="none" d="M0 0h24v24H0z"></path>
                              <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                            </svg>
                          </div>
                        )} */}
                      </figure>
                      <span className="mr-2 lg:mr-4">{item.name}</span>
                      <span className="font-display text-sm font-semibold text-white"></span>
                    </div>
                    <div
                      className="border-jacarta-600  flex w-[12%] items-center whitespace-nowrap border-t py-4"
                      role="cell"
                    >
                      <span className="" data-tippy-content="SEI">
                        <svg className="icon mr-1 h-4 w-4">
                          <use xlinkHref="/icons.svg#icon-SEI"></use>
                        </svg>
                      </span>
                      <span className="text-sm font-medium tracking-tight">
                        {123} sol
                      </span>
                    </div>
                    <div
                      className="border-jacarta-600  flex w-[12%] items-center border-t py-4 px-4"
                      role="cell"
                    >
                      <span className={`text-white`}>{0.5} Sol</span>
                    </div>
                    <div
                      className="border-jacarta-600  flex w-[12%] items-center border-t py-4 px-4"
                      role="cell"
                    >
                      <span className={`text-white`}>{0.45} Sol</span>
                    </div>
                    <div
                      className="border-jacarta-600  flex w-[12%] items-center border-t py-4 px-4 gap-3"
                      role="cell"
                    >
                      <Image
                        src={PhantomLogo}
                        height={24}
                        width={24}
                        alt="SEI"
                        className="max-h-7 h-auto object-cover rounded-full"
                      />
                      <span className="text-sm font-medium tracking-tight">
                        {0.1} Sol
                      </span>
                    </div>
                    <div
                      className="border-jacarta-600  flex w-[24%] items-center border-t py-4 px-4"
                      role="cell"
                    >
                      <span>{(1235).toLocaleString()}</span>
                    </div>
                  </a>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end rankings --> */}
    </>
  );
};

export default SolCollectionList;
